import React from "react";
import {Row, Col, BackTop} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner } from "@reco-w/core-ui";
import { Namespaces, operatingModel } from "@reco-w/merchants-models";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs } from "swiper";
import { R2040ArticleList } from "src/apps/common/r2040.article.list";
import { Consulting } from "src/apps/consulting/consulting";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs]);

export namespace Operating {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, operatingModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.operating;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/operating`);
        }
        componentDidMount() {
            this.dispatch("input", { newsSlides: 3, newsSpace: 0, caseSlides: 2, caseSpace: 40 });
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0, caseSlides: 1, caseSpace: 0 });
            } else {
                this.dispatch("input", { newsSlides: 3, newsSpace: 60, caseSlides: 2, caseSpace: 40 });
            }
        }

        renderUnique() {
            return (
                <div className="block-content">
                    <div className="container">
                        <div className="second-title">
                            <span>独创模式</span>
                        </div>
                        <Row gutter={[40, 20]} className="pv20 unique-row">
                            <Col xs={24} sm={24} md={6}>
                                <div className="ms-title"><img src="assets/images/second/ms-img1.png" /></div>
                                <div className="ms-write mt20">搭建产业优势区域与本地区之间深度经济合作的桥梁，探索“研发孵化在飞地、产业化在本地”的产业发展新模式，实现两地资源效用的最大化。</div>
                            </Col>
                            <Col xs={24} sm={24} md={18}>
                                <div className="ms-img mt20">
                                    <img src="assets/images/second/ms-img2.png" />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            )
        }

        renderStep() {
            return (
                <div className="block-content step-content">
                    <div className="container">
                        <div className="second-title white-color">
                            <span>五大运营步骤</span>
                        </div>
                        <div className="step-box">
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconzuobiao" /></div>
                                <div className="step-box-name">飞地选址</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconxiangmu2" /></div>
                                <div className="step-box-name">空间规划</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconpipei" /></div>
                                <div className="step-box-name">目标设计</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconzhengce" /></div>
                                <div className="step-box-name">政策设计</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconhuiyishi2" /></div>
                                <div className="step-box-name">专业运营</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        renderAdvantage() {
            return (
                <div className="block-content">
                    <div className="container">
                        <div className="second-title">
                            <span>运营优势</span>
                        </div>
                        <Row className="pt20 advantage-row">
                            <Col xs={24} sm={24} md={5}>
                                <div className="advantage-side">
                                    <div className="advantage-side-title">
                                        <div className="size-16">产业招商团队</div>
                                        <div className="primary-color"><i className="icon iconjiahao" /></div>
                                        <div className="size-16">专业化运营团队</div>
                                    </div>
                                    <div className="advantage-side-list">
                                        {
                                            ["招商服务", "产业规划", "科技服务", "建设指导", "政策兑付", "金融服务"].map((item, i) => {
                                                return (
                                                    <div className="advantage-side-item" key={i}>{item}</div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={14}>
                                <div className="advantage-img">
                                    <img src="assets/images/second/yyys-img.png" />
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={5}>
                                <div className="advantage-side">
                                    <div className="advantage-side-title">
                                        <div className="size-16">产业生态资源地</div>
                                    </div>
                                    <div className="advantage-side-list">
                                        {
                                            ["重点项目", "头部企业", "顶尖人才", "峰会活动", "投融资机构", "产业政策", "产业基金"].map((item, i) => {
                                                return (
                                                    <div className="advantage-side-item" key={i}>{item}</div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            )
        }

        renderCase() {
            // const { state } = this.props,
            //     caseSlides = state!.caseSlides,
            //     caseSpace = state!.caseSpace;
            // const anliData = [
            //     {
            //         imgUrl: "assets/images/second/anli-img1.jpg",
            //         title: "外滩飞地",
            //         address: "四川中路126弄25号",
            //         tag: ["高端私董会", "项目路演", "洽谈", "城市会客厅"]
            //     },
            //     {
            //         imgUrl: "assets/images/second/anli-img2.jpg",
            //         title: "闵行飞地",
            //         address: "闵行区浦江镇联航路1588号",
            //         tag: ["飞地孵化", "展示窗口", "人才配套", "招商桥梁"]
            //     },
            //     {
            //         imgUrl: "assets/images/second/anli-img1.jpg",
            //         title: "外滩飞地",
            //         address: "四川中路126弄25号",
            //         tag: ["高端私董会", "项目路演", "洽谈", "城市会客厅"]
            //     },
            //     {
            //         imgUrl: "assets/images/second/anli-img2.jpg",
            //         title: "闵行飞地",
            //         address: "闵行区浦江镇联航路1588号",
            //         tag: ["飞地孵化", "展示窗口", "人才配套", "招商桥梁"]
            //     }
            // ]
            return (
                <div className="block-content case-content">
                    <div className="container">
                        <div className="second-title">
                            <span>案例展示</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            caseType: 1, tagIds: ["887893341038886912"]
                        } as any)}
                    </div>
                </div>
            )
        }

        renderStrategic() {
            const logoData = [
                "assets/images/second/hz-logo1.png",
                "assets/images/second/hz-logo2.png",
                "assets/images/second/hz-logo3.png",
                "assets/images/second/hz-logo4.png",
                "assets/images/second/hz-logo5.png",
                "assets/images/second/hz-logo6.png"
            ]
            return (
                <div className="block-content pb20">
                    <div className="container">
                        <div className="second-title">
                            <span>战略合作</span>
                        </div>
                        <Row gutter={{ xs: 15, sm: 15, md: 75 }} className="pt10 strategic-logo">
                            {
                                logoData.map((item, i) => {
                                    return (
                                        <Col span={8} key={i}>
                                            <div className="strategic-item">
                                                <img src={item} />
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }


        renderNews() {
            return (
                <div className="block-content" style={{ backgroundColor: "#f8f8f8" }}>
                    <div className="container">
                        <div className="second-title">
                            <span>最新动态</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            tagIds: ["887893341089218560"]
                        } as any)}
                        {/* <div className="news-swiper-box">
                            <Swiper
                                slidesPerView={newsSlides}
                                className="news-swiper mt10"
                                style={{ height: 460 }}
                                pagination={true}
                                spaceBetween={newsSpace}
                            // autoplay={{
                            //     delay: 3000,
                            //     disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                            // }}
                            >
                                {newsData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="news-swiper-item">
                                                <div className="news-img">
                                                    <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                </div>
                                                <div className="pg20">
                                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-18 gray-one-color">
                                                        {item.title}
                                                    </Paragraph>
                                                    <Paragraph ellipsis className="mb0 size-14 gray-three-color mt12">
                                                        {item.desc}
                                                    </Paragraph>
                                                    <div className="mt20">
                                                        <span className="list-arrow" />
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div> */}
                    </div>
                </div>
            )
        }

        renderConsult() {
            return <Consulting.Page renderType={1} orderCode="guanwcyzs"></Consulting.Page>
            // return (
            //     <div className="block-content consult-content">
            //         <div className="container">
            //             <div className="second-title line-no white-color">
            //                 <span>立即咨询定制方案</span>
            //             </div>
            //             <div className="consult-form">
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的姓名" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的单位" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的联系方式" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Button type="primary" ghost block shape="round">立即咨询</Button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/banner/yy-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1"><img src="assets/images/banner/fd-text.png" /></div>
                                <div className="banner-text-name2 mt25">建一个载体，聚一个主题，塑一个高地</div>
                            </div>}
                        />
                        {this.renderUnique()}
                        {this.renderStep()}
                        {this.renderAdvantage()}
                        {/*{this.renderCase()}*/}
                        {this.renderStrategic()}
                        {this.renderNews()}
                        {this.renderConsult()}

                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.operating]);
}
